import dayjs from 'dayjs'

// Setup DayJS plugins
import advancedFormat from 'dayjs/plugin/advancedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(advancedFormat)
dayjs.extend(relativeTime)

type DateFormatFunction = (dateTime: string) => string

interface DateTimeFormatHelper {
  toDoMMMYYYY: DateFormatFunction
  toRelativeTimeAgo: DateFormatFunction
}

const dateTimeFormatHelper: DateTimeFormatHelper = {
  toDoMMMYYYY: (dateTime: string) => {
    const parsedDate = dayjs(dateTime)
    return parsedDate.format('Do MMM YYYY')
  },

  toRelativeTimeAgo: (dateTime: string) => {
    const parsedDate = dayjs(dateTime)
    return parsedDate.fromNow()
  },
}

export default dateTimeFormatHelper
